import { render, staticRenderFns } from "./QuotationStepAprroved.vue?vue&type=template&id=ad98d79e&scoped=true"
import script from "./QuotationStepAprroved.vue?vue&type=script&lang=js"
export * from "./QuotationStepAprroved.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepAprroved.vue?vue&type=style&index=0&id=ad98d79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad98d79e",
  null
  
)

export default component.exports